<template>
  <div
      class="setting-field"
      :class="{'disable-html-component': missing}">
    <el-badge
        value="error"
        class="label"
        :hidden="!missing">
      <label> {{ label }} </label>
    </el-badge>
    <el-switch
        v-model="value"
        :disabled="disabled"
        @change="onChange" />
    <span>{{ value ? 'on' : 'off' }}</span>
  </div>
</template>

<script>
import { keys, every, has, set, get, isNumber } from "lodash";

export default {
  name: "SwitchSetting",
  props: {
    config: {
      type: Object,
      required: true,
      validator: function (object) {
        return every(["label", "value", "path"], (k) => has(object, k));
      },
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    },
    value: {
      get() {
        const v = this.config.value;
        return isNumber(v) ? !!v : v;
      },
      set() {},
    },
    label() {
      return this.config.label;
    },
    path() {
      return this.config.path;
    },
    missing() {
      return get(this, "config.missing", false);
    },
    show() {
      return !get(this, "config.removed", false);
    },
    disabled() {
      return !this.isAdmin || get(this, "config.disabled", false);
    },
  },
  methods: {
    isNumber() {
      return isNumber(this.config.value);
    },
    onChange(val) {
      if (this.isNumber()) {
        val = val ? 1 : 0;
      }
      const payload = set({}, this.path, val);
      this.$emit("change", { payload, done: () => (this.config.value = val) });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "settings";
@include settingField();
</style>
